function QuizIntro() {
    return (
        <div className={"quiz-intro"}>
            <h1>Learn</h1>
            <h2>Lunar New Year Phrases</h2>
            <h3>Select a Phrase on the left and learn how to pronounce and write it in chinese!</h3>
        </div>
    )
}

export default QuizIntro
